if( !Array.prototype.limit ) Array.prototype.limit = function ( limit = 0 )
{
    var self = this

    var _ret = []

    if( limit )
    {
        for( var i = 0; i < self.length; i++ )
        {
            if( i < limit )
            {
                _ret.push( self[ i ] )
            }
        }
    }

    return _ret
}

module.exports = {}